module.exports = __webpack_public_path__ + "img/saum_feuerrot_ral3000.dc289b76.jpg";